export default __webpack_public_path__ + "static/media/eps.4967e423.svg";